export default "__VITE_ASSET__mOqnZ_$Y__"